import { useTransContext } from '@mbarzda/solid-i18next'
import type { Component } from 'solid-js'
import { createEffect, For } from 'solid-js'
import type { Grouping } from '../../../features/revenue/domain/models/range'

interface GroupBySelectorProps {
  availableGroupings: Grouping[]
  selectedGrouping: Grouping
  onGroupingChange: (grouping: Grouping) => void
}

const GROUPING_LABELS: Record<Grouping, string> = {
  daily: 'ls_grouping_daily',
  weekly: 'ls_grouping_weekly',
  monthly: 'ls_grouping_monthly'
}

const GroupBySelector: Component<GroupBySelectorProps> = (props) => {
  const [t] = useTransContext()
  let selectRef!: HTMLSelectElement

  // Sync DOM select value after <For> renders new options.
  // Without this, changing available options can reset the native <select>
  // to the first option before SolidJS re-applies the value property.
  createEffect(() => {
    if (props.availableGroupings.length) {
      selectRef.value = props.selectedGrouping
    }
  })

  const handleChange = (e: Event): void => {
    const select = e.target as HTMLSelectElement
    props.onGroupingChange(select.value as Grouping)
  }

  return (
    <select
      ref={selectRef}
      value={props.selectedGrouping}
      onChange={handleChange}
      disabled={props.availableGroupings.length <= 1}
      class="h-10 rounded-lg border border-gray-300 bg-white pl-3 pr-8 py-2.5 text-sm font-medium text-gray-900 shadow-sm transition-colors hover:bg-gray-50 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 disabled:cursor-not-allowed disabled:opacity-50"
    >
      <For each={props.availableGroupings}>
        {(grouping) => <option value={grouping}>{t(GROUPING_LABELS[grouping])}</option>}
      </For>
    </select>
  )
}

export default GroupBySelector
